function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.select.addEventListener('change', this.onSelectChange.bind(this));
    
    // Validate input on manual entry
    if (this.input) {
      this.input.addEventListener('input', this.onInputChange.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
    }
  }

  onInputChange(event) {
    const maxValue = parseInt(this.input.getAttribute('max'), 10);
    const minValue = parseInt(this.input.getAttribute('min'), 10) || 1;
    const currentValue = parseInt(this.input.value, 10);
    const inventoryQuantity = this.input.getAttribute('data-inventory-quantity');

    console.log('QuantityInput - Input Change:', {
      currentValue: currentValue,
      maxValue: maxValue,
      minValue: minValue,
      inventoryQuantity: inventoryQuantity,
      rawInput: this.input.value
    });

    if (!isNaN(currentValue)) {
      if (!isNaN(maxValue) && currentValue > maxValue) {
        console.log('QuantityInput - Adjusting to max:', maxValue);
        this.input.value = maxValue;
      } else if (!isNaN(minValue) && currentValue < minValue) {
        console.log('QuantityInput - Adjusting to min:', minValue);
        this.input.value = minValue;
      }
    }
  }

  onInputBlur(event) {
    const maxValue = parseInt(this.input.getAttribute('max'), 10);
    const minValue = parseInt(this.input.getAttribute('min'), 10) || 1;
    const inventoryQuantity = this.input.getAttribute('data-inventory-quantity');
    let currentValue = parseInt(this.input.value, 10);

    console.log('QuantityInput - Input Blur:', {
      currentValue: currentValue,
      maxValue: maxValue,
      minValue: minValue,
      inventoryQuantity: inventoryQuantity,
      rawInput: this.input.value
    });

    // If empty or invalid, set to min
    if (isNaN(currentValue) || this.input.value === '') {
      console.log('QuantityInput - Empty/invalid, setting to min:', minValue);
      this.input.value = minValue;
      currentValue = minValue;
    }

    // Ensure value is within bounds
    if (!isNaN(maxValue) && currentValue > maxValue) {
      console.log('QuantityInput - Adjusting to max on blur:', maxValue);
      this.input.value = maxValue;
      currentValue = maxValue;
    } else if (!isNaN(minValue) && currentValue < minValue) {
      console.log('QuantityInput - Adjusting to min on blur:', minValue);
      this.input.value = minValue;
      currentValue = minValue;
    }

    if (currentValue !== parseInt(this.input.value, 10)) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  onSelectChange(event) {
    event.preventDefault();
    const previousValue = this.select.value;
    if (previousValue !== this.select.value) this.input.dispatchEvent(this.changeEvent);
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const maxValue = parseInt(this.input.getAttribute('max'), 10);
    const minValue = parseInt(this.input.getAttribute('min'), 10) || 1;
    const inventoryQuantity = this.input.getAttribute('data-inventory-quantity');
    const inventoryPolicy = this.input.getAttribute('data-inventory-policy');

    console.log('QuantityInput - Button Click:', {
      button: event.target.name,
      previousValue: previousValue,
      maxValue: maxValue,
      minValue: minValue,
      inventoryQuantity: inventoryQuantity,
      inventoryPolicy: inventoryPolicy
    });

    if (event.target.name === 'plus') {
      this.input.stepUp();
      // Ensure we don't exceed max
      if (!isNaN(maxValue) && parseInt(this.input.value, 10) > maxValue) {
        console.log('QuantityInput - Limited by max:', maxValue);
        this.input.value = maxValue;
      }
    } else {
      this.input.stepDown();
      // Ensure we don't go below min
      if (!isNaN(minValue) && parseInt(this.input.value, 10) < minValue) {
        console.log('QuantityInput - Limited by min:', minValue);
        this.input.value = minValue;
      }
    }
    
    console.log('QuantityInput - New Value:', this.input.value);
    
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getConfig(type = 'json') {
  return {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary:not(.mobile-facets__summary)').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => {
      // Exclude tab header buttons from close button behavior
      if (!button.closest('.menu-drawer__tab-headers')) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      }
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    // Emit closing event before starting close process
    this.dispatchEvent(new CustomEvent('drawer:closing', {
      bubbles: true,
      detail: { trigger: event }
    }));

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    this.closeMenuDrawer(event);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    // Initialize mobile menu image slider
    this.#initializeImageSlider();

    // Initialize text color state
    this.updateTextColorState();

    // Initialize tab functionality
    this.initializeTabs();
  }

  /**
   * Ensures a first-level menu is expanded when the drawer opens.
   * Prefers "Mężczyzna" (per UX requirement), falls back to the first level-1 item.
   */
  openDefaultFirstLevelMenu() {
    // If something is already open, keep it (don't fight the user/state)
    const alreadyExpanded = this.querySelector('details[open][data-level="1"]');
    if (alreadyExpanded) return;

    const preferredSummary = this.querySelector('[data-menu-image-trigger="Mężczyzna"]');
    const preferredDetails = preferredSummary?.closest('details[data-level="1"]');

    const fallbackDetails = this.querySelector('details[data-level="1"]');
    const detailsToOpen = preferredDetails || fallbackDetails;
    if (!detailsToOpen) return;

    const summary = detailsToOpen.querySelector('summary');
    if (!summary) return;

    detailsToOpen.setAttribute('open', '');
    detailsToOpen.classList.add('menu-opening');
    summary.setAttribute('aria-expanded', true);

    // Keep behavior consistent with submenu open state styling
    const parentMenuElement = detailsToOpen.closest('.has-submenu');
    parentMenuElement && parentMenuElement.classList.add('submenu-open');
  }

  #initializeImageSlider() {
    this.imageSlider = this.querySelector('.menu-drawer__image-slider');
    this.imageSlides = this.querySelectorAll('.menu-drawer__image-slide');
    this.menuTriggers = this.querySelectorAll('[data-menu-image-trigger]');
    this.currentActiveSlide = null;

    if (!this.imageSlider || this.imageSlides.length === 0) return;

    // Set initial active slide
    this.currentActiveSlide = this.querySelector('.menu-drawer__image-slide[data-active="true"]');

    // Highlight the initially active menu item
    if (this.currentActiveSlide) {
      this.#highlightMenuItem(this.currentActiveSlide.dataset.menuTitle);
    }

    // Add event listeners for menu items
    this.menuTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', this.#handleMenuHover.bind(this));
      trigger.addEventListener('focus', this.#handleMenuFocus.bind(this));
    });

    // Auto-slide will be started by updateTextColorState() when menu opens
  }

  #handleMenuHover(event) {
    // Don't handle hover if submenus are open
    const hasExpandedItems = this.querySelector('details[open][data-level="1"], details[open][data-level="2"], details[open][data-level="3"]');
    if (hasExpandedItems) return;

    this.#setActiveSlideByMenuTitle(event.currentTarget.dataset.menuImageTrigger);
  }

  #handleMenuFocus(event) {
    // Don't handle focus if submenus are open
    const hasExpandedItems = this.querySelector('details[open][data-level="1"], details[open][data-level="2"], details[open][data-level="3"]');
    if (hasExpandedItems) return;

    this.#setActiveSlideByMenuTitle(event.currentTarget.dataset.menuImageTrigger);
  }

  #setActiveSlideByMenuTitle(menuTitle) {
    if (!menuTitle) return;

    const targetSlide = Array.from(this.imageSlides).find(slide =>
      slide.dataset.menuTitle === menuTitle
    );

    if (targetSlide && targetSlide !== this.currentActiveSlide) {
      // Remove active state from current slide and menu item
      if (this.currentActiveSlide) {
        this.currentActiveSlide.dataset.active = 'false';
        this.#removeMenuItemHighlight(this.currentActiveSlide.dataset.menuTitle);
      }

      // Set new active slide and highlight menu item
      targetSlide.dataset.active = 'true';
      this.currentActiveSlide = targetSlide;
      this.#highlightMenuItem(menuTitle);

      // Stop auto-slide when user interacts
      this.stopAutoSlide();
    }
  }

  startAutoSlide() {
    if (this.imageSlides.length <= 1) return;

    this.autoSlideInterval = setInterval(() => {
      this.#nextSlide();
    }, 1500);
  }

  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  #nextSlide() {
    if (this.imageSlides.length <= 1) return;

    const currentIndex = Array.from(this.imageSlides).indexOf(this.currentActiveSlide);
    const nextIndex = (currentIndex + 1) % this.imageSlides.length;
    const nextSlide = this.imageSlides[nextIndex];

    if (this.currentActiveSlide) {
      this.currentActiveSlide.dataset.active = 'false';
      this.#removeMenuItemHighlight(this.currentActiveSlide.dataset.menuTitle);
    }

    nextSlide.dataset.active = 'true';
    this.currentActiveSlide = nextSlide;
    this.#highlightMenuItem(nextSlide.dataset.menuTitle);
  }

  #highlightMenuItem(menuTitle) {
    if (!menuTitle) return;

    const menuItem = this.querySelector(`[data-menu-image-trigger="${menuTitle}"]`);
    if (menuItem) {
      menuItem.classList.add('menu-item--highlighted');
    }
  }

  #removeMenuItemHighlight(menuTitle) {
    if (!menuTitle) return;

    const menuItem = this.querySelector(`[data-menu-image-trigger="${menuTitle}"]`);
    if (menuItem) {
      menuItem.classList.remove('menu-item--highlighted');
    }
  }

  #clearAllMenuHighlights() {
    const highlightedItems = this.querySelectorAll('.menu-item--highlighted');
    highlightedItems.forEach(item => {
      item.classList.remove('menu-item--highlighted');
    });
  }

  updateSubmenuParentHighlight() {
    // Clear all highlights first
    this.#clearAllMenuHighlights();

    // Find the parent of the currently expanded submenu
    const expandedSubmenu = this.querySelector('details[open][data-level="1"]');
    if (expandedSubmenu) {
      const parentMenuItem = expandedSubmenu.querySelector('summary.menu-drawer__menu-item');
      if (parentMenuItem) {
        parentMenuItem.classList.add('menu-item--highlighted');

        // Update the image to match the parent menu item
        const menuTitle = parentMenuItem.dataset.menuImageTrigger;
        if (menuTitle) {
          this.setActiveSlideByMenuTitleOnly(menuTitle);
        }
      }
    }
  }

  setActiveSlideByMenuTitleOnly(menuTitle) {
    if (!menuTitle) return;

    const targetSlide = Array.from(this.imageSlides).find(slide =>
      slide.dataset.menuTitle === menuTitle
    );

    if (targetSlide && targetSlide !== this.currentActiveSlide) {
      // Remove active state from current slide
      if (this.currentActiveSlide) {
        this.currentActiveSlide.dataset.active = 'false';
      }

      // Set new active slide (without stopping auto-slide)
      targetSlide.dataset.active = 'true';
      this.currentActiveSlide = targetSlide;
    }
  }

  resetSliderState() {
    if (!this.imageSlides || this.imageSlides.length === 0) return;

    // Clear all active slides
    this.imageSlides.forEach(slide => {
      slide.dataset.active = 'false';
    });

    // Prefer "Mężczyzna" slide when opening drawer, else use first slide
    const preferredSlide = Array.from(this.imageSlides).find(slide => slide.dataset.menuTitle === 'Mężczyzna');
    const slideToActivate = preferredSlide || this.imageSlides[0];
    if (slideToActivate) {
      slideToActivate.dataset.active = 'true';
      this.currentActiveSlide = slideToActivate;

      // Highlight the corresponding menu item
      const menuTitle = this.currentActiveSlide.dataset.menuTitle;
      if (menuTitle) {
        this.#clearAllMenuHighlights();
        this.#highlightMenuItem(menuTitle);
      }
    }

    // Stop any existing auto-slide
    this.stopAutoSlide();
  }

  updateTextColorState() {
    const isMenuDrawerOpen = this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open');
    // For slider functionality, only check if first-level menus are open
    const hasFirstLevelExpanded = this.querySelector('details[open][data-level="1"]');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (!headerWrapper) return;

    if (isMenuDrawerOpen && !hasFirstLevelExpanded) {
      // Menu open, no first-level items expanded - white text, resume slider
      headerWrapper.classList.add('menu-drawer--white-text');
      headerWrapper.classList.remove('menu-drawer--black-text');
      this.startAutoSlide();
    } else if (isMenuDrawerOpen && hasFirstLevelExpanded) {
      // Menu open, first-level items expanded - black text, pause slider
      headerWrapper.classList.add('menu-drawer--black-text');
      headerWrapper.classList.remove('menu-drawer--white-text');
      this.stopAutoSlide();

      // Keep only the parent of expanded submenu highlighted
      this.updateSubmenuParentHighlight();
    } else {
      // Menu closed - remove all text color classes, stop slider
      headerWrapper.classList.remove('menu-drawer--white-text', 'menu-drawer--black-text');
      this.stopAutoSlide();
    }
  }

  initializeTabs() {
    // Initialize tab functionality for 2nd level menus
    const tabHeaders = this.querySelectorAll('[role="tab"]');

    tabHeaders.forEach(header => {
      header.addEventListener('click', this.handleTabClick.bind(this));
      header.addEventListener('keydown', this.handleTabKeydown.bind(this));
    });
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const tabId = clickedTab.getAttribute('data-tab');
    const tabContainer = clickedTab.closest('.menu-drawer__tabs');

    if (!tabContainer) return;

    // Update tab headers
    const allTabs = tabContainer.querySelectorAll('[role="tab"]');
    allTabs.forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    clickedTab.classList.add('active');
    clickedTab.setAttribute('aria-selected', 'true');
    clickedTab.setAttribute('tabindex', '0');

    // Update tab panels
    const allPanels = tabContainer.querySelectorAll('.menu-drawer__tab-panel');
    allPanels.forEach(panel => {
      panel.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
    });

    const targetPanel = tabContainer.querySelector(`#panel-${tabId.replace('tab-', '')}`);
    if (targetPanel) {
      targetPanel.classList.add('active');
      targetPanel.setAttribute('aria-hidden', 'false');
    }
  }

  handleTabKeydown(event) {
    const currentTab = event.currentTarget;
    const tabContainer = currentTab.closest('.menu-drawer__tabs');
    const allTabs = Array.from(tabContainer.querySelectorAll('[role="tab"]'));
    const currentIndex = allTabs.indexOf(currentTab);

    let targetTab = null;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        targetTab = allTabs[currentIndex - 1] || allTabs[allTabs.length - 1];
        break;
      case 'ArrowRight':
        event.preventDefault();
        targetTab = allTabs[currentIndex + 1] || allTabs[0];
        break;
      case 'Home':
        event.preventDefault();
        targetTab = allTabs[0];
        break;
      case 'End':
        event.preventDefault();
        targetTab = allTabs[allTabs.length - 1];
        break;
    }

    if (targetTab) {
      targetTab.focus();
      targetTab.click();
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    // Remove open attribute from main details toggle immediately
    this.mainDetailsToggle.removeAttribute('open');

    // Remove text color classes immediately when closing starts
    const headerWrapper = document.querySelector('.header-wrapper');
    if (headerWrapper) {
      headerWrapper.classList.remove('menu-drawer--white-text', 'menu-drawer--black-text');
    }

    this.mainDetailsToggle.classList.remove('menu-opening');
    // Don't close any submenus - keep their state when drawer is closed
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    // Remove class from header-wrapper
    if (headerWrapper) {
      headerWrapper.classList.remove('menu-drawer-open');
    }

    // Remove class from sticky-header
    const stickyHeader = document.getElementById('sticky-header');
    if (stickyHeader) {
      stickyHeader.classList.remove('menu-drawer-open');
    }

    // Reset header position when menu closes
    this.resetHeaderPosition();

    // Also update search positioning if it exists
    this.updateSearchPosition();

    // Clear all menu item highlights
    this.#clearAllMenuHighlights();

    // Restart auto-slide when menu is closed
    this.stopAutoSlide();
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      if (isOpen) {
        this.closeMenuDrawer(event, summaryElement);
      } else {
        this.openMenuDrawer(summaryElement);
      }
    } else {
      // Close all other open submenus at the same level within the same parent
      const currentLevel = detailsElement.dataset.level;
      const parentContainer = detailsElement.closest('.menu-drawer__inner-submenu') || detailsElement.closest('.menu-drawer__navigation');

      if (parentContainer) {
        const otherDetailsAtSameLevel = parentContainer.querySelectorAll(`details[open][data-level="${currentLevel}"]:not([data-level="0"])`);
        otherDetailsAtSameLevel.forEach(details => {
          if (details !== detailsElement) {
            this.closeSubmenu(details);
          }
        });
      }

      // Remove all menu item highlights when submenu opens
      this.#clearAllMenuHighlights();

      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      // Update text color when submenu opens and then highlight the correct parent
      setTimeout(() => {
        this.updateTextColorState();
        // Ensure the clicked submenu parent is highlighted after text color update
        this.#clearAllMenuHighlights();
        summaryElement.classList.add('menu-item--highlighted');
      }, 15);

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');

        if (detailsElement.dataset.level == 1) {
          const accordionButton = detailsElement.querySelector('summary');
          const height = accordionButton.offsetHeight;
          document.documentElement.style.setProperty('--submenu-header-height', `${parseInt(height)}px`);
          document.querySelector('.menu-drawer').style.setProperty('--submenu-header-height', `${parseInt(height)}px`);
        } else if (detailsElement.dataset.level == 2) {
          const setHeight = detailsElement.closest('.menu-drawer__inner-submenu');
        }
      });
    }
  }

  closeSubmenu(detailsElement) {
    if (detailsElement === this.mainDetailsToggle) {
      return;
    }

    const navContainer = document.querySelector(".menu-drawer__navigation-container");
    if (navContainer) {
      navContainer.style.maxHeight = '';
      navContainer.style.height = '';
    }

    // Remove both open attribute and menu-opening class at the start
    detailsElement.removeAttribute('open');
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);

    // Update text color when submenu closes
    setTimeout(() => {
      this.updateTextColorState();
    }, 10);
  }

  openMenuDrawer(summaryElement) {
    // Reset slider state when opening
    this.resetSliderState();

    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    // Check if transparent header is enabled on homepage
    const headerWrapper = document.querySelector('.header-wrapper');
    const isTransparentHeader = window.location.pathname === '/' &&
      headerWrapper &&
      getComputedStyle(headerWrapper).position === 'absolute';

    let headerBottomPosition;

    // For transparent header, we need to account for the fact that:
    // 1. The announcement bar is now outside the sticky header
    // 2. The header is absolutely positioned
    // 3. The menu drawer should start from the bottom of the actual header element

    if (isTransparentHeader) {
      // For transparent header: force measurement by temporarily changing position if needed
      let headerBottomPosition = 0;

      // Try getting the height directly first
      const headerWrapperRect = headerWrapper.getBoundingClientRect();
      headerBottomPosition = headerWrapperRect.height;

      // If still 0, try the inner header element
      if (headerBottomPosition === 0) {
        const headerRect = this.header.getBoundingClientRect();
        headerBottomPosition = headerRect.height;
      }

      // If still 0, temporarily change position to get real dimensions
      if (headerBottomPosition === 0) {
        const originalPosition = headerWrapper.style.position;
        const originalTop = headerWrapper.style.top;
        const originalLeft = headerWrapper.style.left;

        // Temporarily make it static to measure
        headerWrapper.style.position = 'static';
        headerWrapper.style.top = 'auto';
        headerWrapper.style.left = 'auto';

        // Measure now
        const tempRect = headerWrapper.getBoundingClientRect();
        headerBottomPosition = tempRect.height;

        // Restore original positioning
        headerWrapper.style.position = originalPosition;
        headerWrapper.style.top = originalTop;
        headerWrapper.style.left = originalLeft;
      }

      // Subtract border if present
      if (this.borderOffset && headerBottomPosition > 0) {
        headerBottomPosition -= this.borderOffset;
      }

      headerBottomPosition = Math.floor(headerBottomPosition);
    } else {
      // For normal header: use the actual bottom position from viewport top
      // This includes announcement bar + header since they're in the sticky container
      const stickyHeader = document.getElementById('sticky-header');
      if (stickyHeader) {
        headerBottomPosition = stickyHeader.getBoundingClientRect().bottom;
      } else {
        headerBottomPosition = this.header.getBoundingClientRect().bottom;
      }
    }

    document.documentElement.style.setProperty('--header-bottom-position', `${headerBottomPosition}px`);
    document.querySelector(".menu-drawer").style.setProperty('--header-bottom-position', `${headerBottomPosition}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // Add class to header-wrapper for transparent background
    const headerWrapperForClass = document.querySelector('.header-wrapper');
    if (headerWrapperForClass) {
      headerWrapperForClass.classList.add('menu-drawer-open');
    }

    // Add class to sticky-header for z-index change
    const stickyHeader = document.getElementById('sticky-header');
    if (stickyHeader) {
      stickyHeader.classList.add('menu-drawer-open');
    }

    // Move header up by announcement bar height when menu opens
    this.moveHeaderUpForMenu();

    // Also update search positioning if it exists
    this.updateSearchPosition();

    // Update text color state when menu opens
    setTimeout(() => {
      // Expand default first-level menu so the drawer isn't "empty" on open
      this.openDefaultFirstLevelMenu();

      // Apply the correct header text color + sync slider/highlights to expanded state
      this.updateTextColorState();
    }, 10);

    // Auto-slide is now handled by updateTextColorState()
  }

  moveHeaderUpForMenu() {
    // Use unified header positioning that considers both menu and search states
    this.updateHeaderPosition();
  }

  // Unified method to handle header positioning for both menu and search
  updateHeaderPosition() {
    const announcementBar = document.querySelector('.announcement-bar');
    const stickyHeader = document.getElementById('sticky-header');

    if (!announcementBar || !stickyHeader) return;

    // Check if either menu drawer or search is open
    const isMenuOpen = stickyHeader.classList.contains('menu-drawer-open');
    const isSearchOpen = stickyHeader.classList.contains('search-open');

    // Only move header up if either menu or search is open
    if (!isMenuOpen && !isSearchOpen) {
      this.resetHeaderPosition();
      return;
    }

    const announcementHeight = announcementBar.offsetHeight;

    // Move if any part of announcement bar is visible in viewport
    const announcementRect = announcementBar.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Check if announcement bar intersects with viewport (any part visible)
    const isVisible = announcementRect.bottom > 0 && announcementRect.top < viewportHeight;

    if (isVisible) {
      // Calculate how much of the announcement bar is actually visible
      const visibleHeight = Math.min(announcementRect.bottom, viewportHeight) - Math.max(announcementRect.top, 0);
      const moveAmount = Math.min(visibleHeight, announcementHeight);

      stickyHeader.style.transform = `translateY(-${moveAmount}px)`;
      stickyHeader.style.transition = 'transform 0.3s ease';
    }
  }

  resetHeaderPosition() {
    const stickyHeader = document.getElementById('sticky-header');

    if (stickyHeader) {
      stickyHeader.style.transform = '';
      stickyHeader.style.transition = 'transform 0.3s ease';
    }
  }

  // Update search positioning when mobile drawer state changes
  updateSearchPosition() {
    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch && typeof predictiveSearch.updateHeaderPosition === 'function') {
      predictiveSearch.updateHeaderPosition();
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);


class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('sticky-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();

    // Only close search modal if search is not open (prevent closing on scroll)
    const stickyHeader = document.getElementById('sticky-header');
    if (stickyHeader && !stickyHeader.classList.contains('search-open')) {
      this.closeSearchModal();
    }
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button:not(.product__media-badge)');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="product-slider-previous"]');
    this.nextButton = this.querySelector('button[name="product-slider-next"]');
    this.paginationDots = this.querySelectorAll('.slider-pagination__dot');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    // Add event listeners for pagination dots
    this.paginationDots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => this.onDotClick(e, index));
    });
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    // Update page counter if it exists
    if (this.pageCount && this.pageTotal) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;
      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    } else {
      // For mobile pagination, calculate based on single slide view
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth);
    }

    // Update navigation buttons
    if (this.prevButton && this.nextButton) {
      if (this.currentPage === 1 || this.currentPage === 0) {
        this.prevButton.setAttribute('disabled', true);
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      const maxPage = this.pageCount ? this.totalPages : this.sliderItems.length - 1;
      if (this.currentPage >= maxPage) {
        this.nextButton.setAttribute('disabled', true);
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    // Update pagination dots
    this.updatePaginationDots();
  }

  updatePaginationDots() {
    if (!this.paginationDots.length) return;

    const currentIndex = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth);

    this.paginationDots.forEach((dot, index) => {
      const isActive = index === currentIndex;
      dot.classList.toggle('slider-pagination__dot--active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const slideScrollPosition = event.currentTarget.name === 'product-slider-next'
      ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
      : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }

  onDotClick(event, index) {
    event.preventDefault();
    event.stopPropagation();

    const targetScrollPosition = index * this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: targetScrollPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();


    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateColorSwatches();
      this.updateQuantityInput();
    }
  }

  updateColorSwatches() {
    // Get variant options from product data
    const productDataScript = document.querySelector(`[id^="product-data-"]`);
    if (!productDataScript) return;

    try {
      const productData = JSON.parse(productDataScript.textContent);
      const variantOptions = productData.variantOptions;

      // Dispatch custom event for color swatches to listen to
      const event = new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant,
          variantOptions: variantOptions
        },
        bubbles: true
      });
      document.dispatchEvent(event);
    } catch (e) {
      console.error('Error updating color swatches:', e);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input && this.currentVariant) {
        input.value = this.currentVariant.id;
        // Update inventory data attributes
        if (this.currentVariant.inventory_quantity !== undefined) {
          input.setAttribute('data-inventory-quantity', this.currentVariant.inventory_quantity || '');
        }
        if (this.currentVariant.inventory_policy !== undefined) {
          input.setAttribute('data-inventory-policy', this.currentVariant.inventory_policy || '');
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Trigger button state check on product-form
        const productFormElement = productForm.closest('product-form');
        if (productFormElement && typeof productFormElement.checkButtonState === 'function') {
          setTimeout(() => productFormElement.checkButtonState(), 100);
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destinations = document.querySelectorAll(`#${id}`);
        const source = html.getElementById(id);

        if (source && destinations.length > 0) {
          destinations.forEach(destination => {
            destination.innerHTML = source.innerHTML;
          });
        }

        destinations.forEach(destination => {
          destination.classList.remove('visibility-hidden');
        });
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateQuantityInput() {
    if (!this.currentVariant) return;

    const quantityInput = document.querySelector(`#product-form-${this.dataset.section} input[name="quantity"]`);
    if (!quantityInput) return;

    const inventoryQuantity = this.currentVariant.inventory_quantity;
    const inventoryPolicy = this.currentVariant.inventory_policy;

    console.log('VariantSelects - updateQuantityInput:', {
      variantId: this.currentVariant.id,
      variantTitle: this.currentVariant.title,
      inventoryQuantity: inventoryQuantity,
      inventoryPolicy: inventoryPolicy,
      variantObject: this.currentVariant
    });

    // Set max quantity based on inventory policy
    let maxQuantity = 999; // Default for unlimited or continue policy
    if (inventoryPolicy !== 'continue' && inventoryQuantity !== null && !isNaN(inventoryQuantity)) {
      maxQuantity = inventoryQuantity;
    }

    console.log('Setting max quantity:', {
      maxQuantity: maxQuantity,
      inventoryPolicy: inventoryPolicy,
      inventoryQuantity: inventoryQuantity
    });

    quantityInput.setAttribute('max', maxQuantity);
    quantityInput.setAttribute('data-inventory-quantity', inventoryQuantity || '');
    quantityInput.setAttribute('data-inventory-policy', inventoryPolicy || '');

    // Update quantity-input wrapper if it exists
    const quantityInputWrapper = quantityInput.closest('quantity-input');
    if (quantityInputWrapper) {
      quantityInputWrapper.setAttribute('data-variant-id', this.currentVariant.id);
      quantityInputWrapper.setAttribute('data-inventory-quantity', inventoryQuantity || '');
      quantityInputWrapper.setAttribute('data-inventory-policy', inventoryPolicy || '');
    }

    // If current quantity exceeds max, adjust it
    const currentQuantity = parseInt(quantityInput.value, 10);
    if (currentQuantity > maxQuantity) {
      console.log('Adjusting quantity from', currentQuantity, 'to', maxQuantity);
      quantityInput.value = maxQuantity;
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);



//Custom functions

// Desktop hover behavior for header inline menu <details>
(() => {
  const mediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
  let unbindHandlers = [];

  const cleanup = () => {
    for (const off of unbindHandlers) off();
    unbindHandlers = [];
  };

  const openDetails = (details, summary) => {
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
    summary?.setAttribute('aria-expanded', 'true');
  };

  const closeDetailsIfNoFocus = (details, summary) => {
    setTimeout(() => {
      if (!details.contains(document.activeElement)) {
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
      }
    }, 40);
  };

  const bind = () => {
    cleanup();
    if (!mediaQuery.matches) return;

    const detailsNodes = document.querySelectorAll('.header__inline-menu .header__menu-disclosure');
    for (const details of detailsNodes) {
      const summary = details.querySelector('summary');
      if (!summary) continue;

      const onMouseEnter = () => openDetails(details, summary);
      const onMouseLeave = () => closeDetailsIfNoFocus(details, summary);
      const onFocusOut = () => closeDetailsIfNoFocus(details, summary);
      const onKeyUp = (event) => {
        if (event.code?.toUpperCase() !== 'ESCAPE') return;
        if (!details.hasAttribute('open')) return;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      };

      details.addEventListener('mouseenter', onMouseEnter);
      details.addEventListener('mouseleave', onMouseLeave);
      details.addEventListener('focusout', onFocusOut);
      details.addEventListener('keyup', onKeyUp);

      unbindHandlers.push(() => {
        details.removeEventListener('mouseenter', onMouseEnter);
        details.removeEventListener('mouseleave', onMouseLeave);
        details.removeEventListener('focusout', onFocusOut);
        details.removeEventListener('keyup', onKeyUp);
      });
    }
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', bind);
  } else {
    // Safari < 14
    mediaQuery.addListener(bind);
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', cleanup);
})();
if ((typeof window.Trend) == 'undefined') {
  window.Trend = {};
}

Trend.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Trend.getProductName = function (productJSON) {
  let finalName = '';
  let prodName = productJSON.title.toLowerCase();
  let prodVendor = productJSON.vendor.toLowerCase();
  finalName = prodName.replace(prodVendor, "").trim();

  let colourTags = [];
  for (let i = 0; i < productJSON.tags.length; i++) {
    let tag = productJSON.tags[i].toLowerCase();
    if (tag.indexOf("colour") > -1) {
      colourTags.push(tag.replace("colour:", "").trim());
    }
  }

  for (let j = 0; j < colourTags.length; j++) {
    let c = colourTags[j];
    if (finalName.indexOf(c) > -1) {
      finalName = finalName.replace(c, "").trim();
      break;
    }
  }

  return finalName;
}

Trend.getProductColor = function (productJSON) {
  let prodName = product.title.toLowerCase();
  let prodVendor = product.vendor.toLowerCase();
  let prodNameWithoutVendor = prodName.replace(prodVendor, "").trim();
  let color = '';

  let colourTags = [];
  for (let i = 0; i < product.tags.length; i++) {
    let tag = product.tags[i].toLowerCase();
    if (tag.indexOf("colour") > -1) {
      colourTags.push(tag.replace("colour:", "").trim());
    }
  }

  for (let j = 0; j < colourTags.length; j++) {
    let c = colourTags[j];

    if (prodNameWithoutVendor.indexOf(c) > -1) {
      color = c;
      break;
    }
  }

  return color;
}

Trend.Currency = (function () {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();


/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

Trend.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();


Trend.Color = (function () {
  function hexToRgb(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  function luminance(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928
        ? v / 12.92
        : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  function calculateColorContrast(hex1, hex2) {
    var color1 = hexToRgb(hex1);
    var color2 = hexToRgb(hex2);
    var color1luminance = luminance(color1.r, color1.g, color1.b);
    var color2luminance = luminance(color2.r, color2.g, color2.b);
    return color1luminance > color2luminance
      ? ((color2luminance + 0.05) / (color1luminance + 0.05))
      : ((color1luminance + 0.05) / (color2luminance + 0.05));
  }

  function getContrastClass(hex, backgroundHex) {
    return calculateColorContrast(hex, backgroundHex) > 0.90 ? 'color-swatch--light' : ''
  }

  return {
    _getColorContrastRatio: calculateColorContrast,
    _getColorContrastClass: getContrastClass
  }
})();

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    // Check if using custom dropdown
    this.customDropdown = this.querySelector('custom-dropdown');

    if (this.customDropdown) {
      this.initCustomDropdown();
    } else {
      // Fallback to original disclosure pattern
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
  }

  initCustomDropdown() {
    // Wait for custom dropdown to be defined
    if (!customElements.get('custom-dropdown')) {
      setTimeout(() => this.initCustomDropdown(), 100);
      return;
    }

    // Listen for change events from custom dropdown
    this.customDropdown.addEventListener('change', (event) => {
      this.elements.input.value = event.detail.value;
      this.querySelector('form')?.submit();
    });
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector('form')?.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);